<template>
    <div>

        <b-modal id="bv-modal-wizard" hide-footer size="lg">
<!--            <template v-slot:modal-title>-->
<!--                Using <code>$bvModal</code> Methods-->
<!--            </template>-->
            <div class="modal-wizard">
                <b-row>
                    <b-col lg="9" cols="12">
                        <h6><b>{{$t("firstLogin.hello")}}</b></h6>
                        <p class="mb-5 mt-3">{{$t("firstLogin.toGetTheActivation")}}</p>
                    </b-col>
                    <b-col lg="3"  class="move-img-left d-none d-lg-flex">
                        <svg clip-rule="evenodd" fill-rule="evenodd" height="100" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-miterlimit="2.61313"><g stroke="#2cb894"><path d="m35.14 29.34h30.27v34.93h-30.27z" stroke-width="2"/><path d="m28.23 29.34h44.11v53.07h-44.11z" stroke-width="2.08"/><path d="m43.37 69.85h13.81v6.38h-13.81z" stroke-width="2"/></g><g stroke="#373435" stroke-width="2.08"><path d="m45.32 39.05h9.92v6.36h-9.92z"/><path d="m50.28 45.41v6.36"/><path d="m78.56 9.63v13.36"/><path d="m85.24 16.31h-13.35"/><path d="m86.61 20.91v5.53"/><path d="m89.37 23.68h-5.52"/><path d="m84.43 52.75v8.38"/><path d="m88.62 56.94h-8.38"/><path d="m12.41 37.4v8.36"/><path d="m16.59 41.58h-8.36"/></g></g></svg>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="point-list">
                        <div class="mb-4">
                            <span class="dot bar">1</span>
                            <span><p>{{$t("firstLogin.goTo")}}</p></span>
                        </div>
                        <div class="mb-4">
                            <span class="dot">2</span>
                            <span><p>{{$t("firstLogin.pressBtn")}}</p></span>
                        </div>
                        <div class="mb-4">
                            <span class="dot">3</span>
                            <span><p>{{$t("firstLogin.enterSnNumber")}}</p></span>
                        </div>
                        <div>
                            <span class="dot">4</span>
                            <span><p>{{$t("firstLogin.addActive")}}</p></span>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="modal__footer--inside modal__footer--color">
                <div class="modal__footer--left">
                    <b-button  variant="-ternary btn--outline" @click="$bvModal.hide('bv-modal-wizard')">
                        {{$t("firstLogin.close")}}
                    </b-button>
                </div>
                <div class="modal__footer--right">
                    <b-button @click="goToPrinterPage()" variant="-primary">
                        {{$t("firstLogin.addPrinter")}}
                    </b-button>
                </div>

            </div>
        </b-modal>
    </div>

</template>

<script>
  export default {
    name: "FirstLogin",
    methods:{
      goToPrinterPage(){
        this.$router.push({ path: '/printers/add-printer/' })
        this.$bvModal.hide('bv-modal-wizard')
      }
    },
    mounted() {
      this.$bvModal.show('bv-modal-wizard')
    }
  }
</script>

<style scoped lang="scss">
    .move-img-left{
        justify-content: flex-end;
        display: flex;
        svg{
            position: relative;
            top: -20px;
            right: -5px;
        }
    }
    .modal-wizard{
        padding: 30px;
    }
    .dot{
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background-color: #2cb894;
        height: 23px;
        width: 23px;
        font-size: 12px;
        padding: 4px;
        line-height: 11px;
        font-weight: 700;
        color: white;
        border-radius: 100%;
        margin-right: 20px;
        float: left;
    }
    .point-list{
        .mb-4{
            position: relative;
            &:after{
                display: block;
                width: 3px;
                content: "";
                height: calc(100% + 9px);
                margin-bottom: 10px;
                background-color: #2cb894;
                top: 20px;
                position: absolute;
                left: 10px;
            }
        }
    }
</style>
